import { generatePublicId } from 'flow/service/publicIds';
import type { SchemaInstance, WorkflowProps } from 'flow/store/engine/types';
import type { Snapshot, WorkflowDiff, WorkflowHistoryEntry } from 'flow/store/redux/types';
import type { Delta } from 'jsondiffpatch';
import * as jsondiffpatch from 'jsondiffpatch';
import { historyAction } from './constants';
import type { HistoryAction } from './constants';

export function createSnapshot<T>(args: { data: T }): Snapshot<T> {
  return {
    snapshotId: generatePublicId('snapshot'),
    data: args.data,
  };
}

export function trimSubsequentSnapshots(
  snapshots: Snapshot<unknown>[],
  snapshotId: Snapshot<unknown>['snapshotId'],
) {
  const snapshotIndex = snapshots.findIndex(snapshot => snapshot.snapshotId === snapshotId);
  return snapshotIndex === -1
    ? snapshots.slice()
    : snapshots.slice(0, snapshotIndex + 1);
}

export function isUndo(action: HistoryAction): boolean {
  return action === historyAction.undo;
}

export function computeDiff(initial: unknown, current: unknown): Delta {
  return jsondiffpatch.diff(initial, current);
}

export function canRedo(
  history: WorkflowHistoryEntry[],
  historyIndex: number,
): boolean {
  return historyIndex < history.length - 1;
}

export function removeRedoStack(
  history: WorkflowHistoryEntry[],
  historyIndex: number,
): WorkflowHistoryEntry[] {
  return history.slice(0, historyIndex + 1);
}

export function diffWorkflowState(
  initial: {
    workflowData: Partial<SchemaInstance>;
    workflowProps: WorkflowProps;
  },
  current: {
    workflowData: Partial<SchemaInstance>;
    workflowProps: WorkflowProps;
  },
): WorkflowDiff {
  return {
    workflowData: computeDiff(initial.workflowData, current.workflowData),
    workflowProps: computeDiff(initial.workflowProps, current.workflowProps),
  };
}
